import * as React from 'react';
import { CheckoutOrderFragment } from '@websky/graphql';

interface ExchangeContextProps {
	updateOrder: () => Promise<CheckoutOrderFragment>;
}

const ExchangeContext = React.createContext<ExchangeContextProps>(null!);

export function useExchange() {
	return React.useContext(ExchangeContext);
}

const ExchangeProvider: React.FC<ExchangeContextProps> = ({ children, ...props }) => {
	return <ExchangeContext.Provider value={props}>{children}</ExchangeContext.Provider>;
};

export default ExchangeProvider;
